import { all } from 'redux-saga/effects';
import watchSignalRSaga from './signalR/signalRSaga';

export default function* rootSaga() {
  yield all([watchSignalRSaga()]);
}
